import request from '@/utils/request'

const api = {
    pageQuery: "/contact/getPageList",
    updateStatus: "/contact/updateStatus",
}

export default api

export function pageQuery(data){
    return request({
        url: api.pageQuery,
        method: 'post',
        data
    })
}

export function updateStatus(data){
    return request({
        url: api.updateStatus,
        method: 'post',
        data
    })
}

